import { Row, Col, Button } from 'reactstrap';
import * as Icon from 'react-feather';
import PropTypes from 'prop-types';

function FormActionsDatosEscolares({ userOU }) {
  return (
    <Row>
      <Col sm="12" className="mt-1 mt-md-0">
        {userOU.centro !== 'ORIENTACIÓN' ? (
          <Button type="submit" color="success" className="mt-3 w-auto">
            <Icon.Save />
          </Button>
        ) : (
          ''
        )}
      </Col>
    </Row>
  );
}

FormActionsDatosEscolares.propTypes = {
  userOU: PropTypes.object.isRequired,
};

export default FormActionsDatosEscolares;
